import React from 'react';
import styles from './OnboardingMocks.module.scss';

const ClientSuccessMock: React.FC = () => (
  <div className={styles.shell} aria-hidden>
    <div className={styles.chrome}>
      <span className={styles.chromeDot} />
      <span className={styles.chromeDot} />
      <span className={styles.chromeDot} />
      <span>Clientes · MayorX</span>
    </div>
    <div className={styles.body}>
      <div className={styles.toolbar}>
        <span className={styles.toolbarTitle}>Directorio</span>
        <span className={styles.pill}>+ Nuevo</span>
      </div>
      <div className={styles.clientCard}>
        <div className={styles.clientName}>DISTRIBUIDORA ANDINA, C.A.</div>
        <div className={styles.clientLine}>J-40123456-7 · Código CLI-001</div>
        <div className={styles.clientLine}>Zona Centro · Crédito 15 días</div>
      </div>
      <div className={styles.row} style={{ marginTop: 6 }}>
        <div className={styles.rowMeta}>
          <div className={styles.rowName}>LA CASA DEL HARDWARE C.A.</div>
          <div className={styles.rowSub}>J-29876543-1 · CLI-002</div>
        </div>
        <span className={styles.badge}>Activo</span>
      </div>
    </div>
  </div>
);

export default ClientSuccessMock;
